import { Logger } from './logger';
export class Destination {
    constructor(options) {
        this.logger = new Logger({
            enableDebugLogging: options.debugLog,
            debugFn: options.logDebug,
            infoFn: options.logInfo,
            warnFn: options.logWarn,
            errorFn: options.logError,
        });
    }
}
//# sourceMappingURL=bridgebase.js.map